import TourneyInTheMoneyHandler from "../../handlers/game/TourneyInTheMoneyHandler";
import ActiveGamesHandler from "../../handlers/lobby/ActiveGamesHandler";
import ChipsReloadAckHandler from "../../handlers/lobby/ChipsReloadAckHandler";
import DynamicPrivateTableLobbyDataHandler from "../../handlers/lobby/DynamicPrivateTableLobbyDataHandler";
import DynamicPrivateTableStatusChangeHandler from "../../handlers/lobby/DynamicPrivateTableStatusChangeHandler";
import DynamicTourneyLobbyDataHandler from "../../handlers/lobby/DynamicTourneyLobbyDataHandler";
import FavouriteSaveAckHandler from "../../handlers/lobby/FavoriteSaveAckHandler";
import FavouriteTablesHandler from "../../handlers/lobby/FavouriteTablesHandler";
import GameActiveStatusHandler from "../../handlers/lobby/GameActiveStatusHandler";
import GameDefinitionUpdateHandler from "../../handlers/lobby/GameDefinitionUpdateHandler";
import GetFunChipsBalanceAckHandler from "../../handlers/lobby/GetFunChipsBalanceAckHandler";
import HandRankingTagLineHandler from "../../handlers/lobby/HandRankingTagLineHandler";
import HeartBeatLobbyHandler from "../../handlers/lobby/HeartBeatLobbyHandler";
import LackHandler from "../../handlers/lobby/LackHandler";
import LobbyConnectionAckHandler from "../../handlers/lobby/LobbyConnectionAckHandler";
import LobbyDataHandler from "../../handlers/lobby/LobbyDataHandler";
import LobbyReconnectionAckHandler from "../../handlers/lobby/LobbyReconnectionAckHandler";
import LockedBetsLobbyHandler from "../../handlers/lobby/LockedBetsLobbyHandler";
import PlayerConfigHandler from "../../handlers/lobby/PlayerConfigHandler";
import PrivateTableCreateGameDefAckHandler from "../../handlers/lobby/PrivateTableCreateGameDefAckHandler";
import PrivateTableCreateGameDefFailureHandler from "../../handlers/lobby/PrivateTableCreateGameDefFailureHandler";
import PrivateTableGameDefInfoFailure from "../../handlers/lobby/PrivateTableGameDefInfoFailure";
import PrivateTableGameDefInfoHandler from "../../handlers/lobby/PrivateTableGameDefInfoHandler";
import PrivateTableGameDefPlayerCount from "../../handlers/lobby/PrivateTableGameDefPlayerCount";
import PrivateTablesLobbyDataHandler from "../../handlers/lobby/PrivateTablesLobbyDataHandler";
import SpecialBetGameActiveStatusHandler from "../../handlers/lobby/SpecialBetGameActiveStatusHandler";
import SpecialBetHandler from "../../handlers/lobby/SpecialBetHandler";
import TourneyCancleHandler from "../../handlers/lobby/TourneyCancleHandler";
import TourneyCompleteHandler from "../../handlers/lobby/TourneyCompleteHandler";
import TourneyDepositorTicketReceiveHandler from "../../handlers/lobby/TourneyDepositorTicketReceiveHandler";
import TourneyDynamicCountsUpdateHandler from "../../handlers/lobby/TourneyDynamicCountsUpdateHandler";
import TourneyFlightQualifiedPlayersAckHandler from "../../handlers/lobby/TourneyFlightQualifiedPlayersAckHandler";
import TourneyFlightStackDetailsAckHandler from "../../handlers/lobby/TourneyFlightStackDetailsAckHandler";
import TourneyInBreakHandler from "../../handlers/lobby/TourneyInBreakHandler";
import TourneyInfoAckHandler from "../../handlers/lobby/TourneyInfoAckHandler";
import TourneyInTheBubbleHandler from "../../handlers/lobby/TourneyInTheBubbleHandler";
import TourneyLateRegEndedHandler from "../../handlers/lobby/TourneyLateRegEndedHandler";
import TourneyLobbydataHandler from "../../handlers/lobby/TourneyLobbydataHandler";
import TourneyNewChildTourneyHandler from "../../handlers/lobby/TourneyNewChildTourneyHandler";
import TourneyPlayerAutoRegisteredHandler from "../../handlers/lobby/TourneyPlayerAutoRegisteredHandler";
import TourneyPlayerStatusHandler from "../../handlers/lobby/TourneyPlayerStatusHandler";
import TourneyPrizeHandler from "../../handlers/lobby/TourneyPrizeHandler";
import TourneyPrizePoolUpdateHandler from "../../handlers/lobby/TourneyPrizePoolUpdateHandler";
import TourneyRanksDataHandler from "../../handlers/lobby/TourneyRanksDataHandler";
import TourneyRegisteredCountHandler from "../../handlers/lobby/TourneyRegisteredCountHandler";
import TourneyRemoveHandler from "../../handlers/lobby/TourneyRemoveHandler";
import TourneySlabChangeHandler from "../../handlers/lobby/TourneySlabChangeHandler";
import TourneyStartHandler from "../../handlers/lobby/TourneyStartHandler";
import TourneyStatusChangeHandler from "../../handlers/lobby/TourneyStatusChangeHandler";
import TourneyTableDataHandler from "../../handlers/lobby/TourneyTableDataHandler";
import TourneyTicketsHandler from "../../handlers/lobby/TourneyTicketsHandler";
import UpdateDepositorTourneyHandler from "../../handlers/lobby/UpdateDepositorTourneyHandler";
import UpdatePlayerCountHandler from "../../handlers/lobby/UpdatePlayerCountHandler";
import TableListViewAckHandler from "../../handlers/lobby/TableListViewAckHandler";
import RefreshTableListViewAckHandler from "../../handlers/lobby/RefreshTableListViewAckHandler";
import RefreshTableDataHandler from "../../handlers/lobby/RefreshTableDataHandler";
import LobbyService from "../../redux/services/LobbyService";
import BaseClient from "../BaseClient";
import Configuration from "../Configuration";
import LobbyListener from "../LobbyListener";
import * as Constants from "../../data/Constants";
import RoomIDUpdateHandler from "@/Poker/handlers/lobby/RoomIDUpdateHandler";
import RoomTableStatusHandler from "@/Poker/handlers/lobby/RoomTableStatusHandler";


function createLobbyConnection(state, dispatchFunction) {
  let clientType = "mipman"; //TODO: need to validate this.
  let returnArray = [];
  let lobbyService = new LobbyService(state, dispatchFunction);

  let serverAddress = import.meta.env.VITE_REACT_APP_LOBBY_SERVER;
  let serverPort = import.meta.env.VITE_REACT_APP_LOBBY_PORT;
  let redirectionURL = "";

  returnArray.push(serverAddress);
  returnArray.push(redirectionURL);

  let handlersList = {};
  handlersList["ld"] = new LobbyDataHandler(lobbyService);
  // handlersList["blockstate"] = new BlockStateHandler(lobbyService);
  handlersList["cona"] = new LobbyConnectionAckHandler(lobbyService);
  if (!Constants.FUN_CHANNELS.includes(state.getState().lobby.channel)) {
    handlersList["lack"] = new LackHandler(lobbyService);
    handlersList["activegames"] = new ActiveGamesHandler(lobbyService);
    handlersList["tourneyinfoa"] = new TourneyInfoAckHandler(lobbyService);
    handlersList["trc"] = new TourneyRegisteredCountHandler(lobbyService);
    handlersList["tsc"] = new TourneyStatusChangeHandler(lobbyService);
    handlersList["tps"] = new TourneyPlayerStatusHandler(lobbyService);
    handlersList["tld"] = new TourneyLobbydataHandler(lobbyService);
    handlersList["tourneystart"] = new TourneyStartHandler(lobbyService);
    handlersList["dtld"] = new DynamicTourneyLobbyDataHandler(lobbyService);
    handlersList["tourneyprize"] = new TourneyPrizeHandler(lobbyService);
    handlersList["tourneycomplete"] = new TourneyCompleteHandler(lobbyService);
    handlersList["ranksdata"] = new TourneyRanksDataHandler(lobbyService);
    handlersList["tourneycancel"] = new TourneyCancleHandler(lobbyService);
    handlersList["tourneylateregended"] = new TourneyLateRegEndedHandler(
      lobbyService
    );
    handlersList["tickets"] = new TourneyTicketsHandler(lobbyService);
    handlersList["newchildtourney"] = new TourneyNewChildTourneyHandler(
      lobbyService
    );
    handlersList["tourneyremove"] = new TourneyRemoveHandler(lobbyService);
    handlersList["tcd"] = new TourneyDynamicCountsUpdateHandler(lobbyService);
    handlersList["playerautoregistered"] =
      new TourneyPlayerAutoRegisteredHandler(lobbyService);
    handlersList["slabchange"] = new TourneySlabChangeHandler(lobbyService);
    handlersList["prizepoolupdate"] = new TourneyPrizePoolUpdateHandler(
      lobbyService
    );
    handlersList["tabledata"] = new TourneyTableDataHandler(lobbyService);
    handlersList["updatedepositortourney"] = new UpdateDepositorTourneyHandler(
      lobbyService
    );
    handlersList["depositorpopup"] = new TourneyDepositorTicketReceiveHandler(
      lobbyService
    );
    handlersList["hrtl"] = new HandRankingTagLineHandler(lobbyService);
  }

  handlersList["gu"] = new GameDefinitionUpdateHandler(lobbyService);
  handlersList["upc"] = new UpdatePlayerCountHandler(lobbyService);
  handlersList["g"] = new HeartBeatLobbyHandler(lobbyService);

  handlersList["rcona"] = new LobbyReconnectionAckHandler(lobbyService);
  // handlersList["conf"] = new ConnectionFailHandler(lobbyService);
  // handlersList["opengame"] = new openGameDefinitionsHandler(lobbyService);
  // handlersList["closegame"] = new closeGameDefinitionsHandler(lobbyService);
  handlersList["gameactivestatus"] = new GameActiveStatusHandler(lobbyService);
  handlersList["lockedbets"] = new LockedBetsLobbyHandler(lobbyService);
  handlersList["playerconfig"] = new PlayerConfigHandler(lobbyService);
  handlersList["chipsreloada"] = new ChipsReloadAckHandler(lobbyService);
  handlersList["getplayerchipsa"] = new GetFunChipsBalanceAckHandler(
    lobbyService
  );
  handlersList["inthemoney"] = new TourneyInTheMoneyHandler(lobbyService);
  handlersList["breakstart"] = new TourneyInBreakHandler(lobbyService);

  handlersList["specialbet"] = new SpecialBetHandler(lobbyService);
  handlersList["sbgu"] = new SpecialBetGameActiveStatusHandler(lobbyService);
  handlersList["flightqualifiedplayersa"] =
    new TourneyFlightQualifiedPlayersAckHandler(lobbyService);
  handlersList["flightstackdetailsa"] = new TourneyFlightStackDetailsAckHandler(
    lobbyService
  );
  handlersList["flightstackdetailsf"] = new TourneyFlightStackDetailsAckHandler(
    lobbyService
  );

  // Private table handlers
  handlersList["ptcreategda"] = new PrivateTableCreateGameDefAckHandler(
    lobbyService
  );
  handlersList["ptcreategdf"] = new PrivateTableCreateGameDefFailureHandler(
    lobbyService
  );
  handlersList["privatetablesld"] = new PrivateTablesLobbyDataHandler(
    lobbyService
  );
  handlersList["dptld"] = new DynamicPrivateTableLobbyDataHandler(lobbyService);
  handlersList["dptsc"] = new DynamicPrivateTableStatusChangeHandler(
    lobbyService
  );

  handlersList["privatetableinfoa"] = new PrivateTableGameDefInfoHandler(
    lobbyService
  );
  handlersList["privateTableinfof"] = new PrivateTableGameDefInfoFailure(
    lobbyService
  );
  handlersList["privatetablespc"] = new PrivateTableGameDefPlayerCount(
    lobbyService
  );
  handlersList["inthebubble"] = new TourneyInTheBubbleHandler(lobbyService);
  handlersList["tablelistviewa"] = new TableListViewAckHandler(lobbyService);
  handlersList["refreshtablelistviewa"] = new RefreshTableListViewAckHandler(lobbyService);
  handlersList["refreshtabledata"] = new RefreshTableDataHandler(lobbyService); // need for desktop
  handlersList["roomidupdate"] = new RoomIDUpdateHandler(lobbyService);
  handlersList["roomtablestatus"] = new RoomTableStatusHandler(lobbyService);

  handlersList["favorite"] = new FavouriteTablesHandler(lobbyService);
  handlersList["favoritesaveack"] = new FavouriteSaveAckHandler(lobbyService);
  let configuration = new Configuration();
  configuration.setHandlersList(handlersList);

  configuration.setConnectionType(import.meta.env.VITE_REACT_APP_CONNECTION_TYPE);
  configuration.setServerAddress(serverAddress);
  configuration.setServerPort(serverPort);

  // configuration.setHeartBeatMessage("g#");
  configuration.setHeartBeatMessage("g");
  configuration.setHeartBeatInterval(3);
  configuration.setConnectionTimeout(10);
  configuration.setReadTimeout(15);
  configuration.setReconnectionTimeout(10);
  configuration.setProtocolDelimiter("#");
  configuration.setReconnectionMode(false);

  let clientListener = new LobbyListener(state, dispatchFunction, clientType);
  let baseClient = new BaseClient(
    state,
    configuration,
    clientListener,
    "lobbyListener"
  );
  clientListener.setCommunicationChannel(baseClient);
  baseClient.start();

  lobbyService.messageHandler = clientListener;

  returnArray.push(baseClient);
  // returnArray.push(googleClientId);

  //CleverTap changes
  return returnArray;
}

export default createLobbyConnection;
